// Module
var code = "<kendo-grid id=\"databasesGrid\" k-scope-field=\"databasesGrid\" flowingly-grid grid-init-done=\"$ctrl.gridInitDone\" grid-need-resize=\"$ctrl.gridNeedResize\" offset=\"300\" no-rows=\"$ctrl.noRows\" options=\"$ctrl.options\" class=\"runner-grid-default\"> </kendo-grid> ";
// Exports
export default code;